"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsNullOrUndef_1 = __importDefault(require("../../typeAssertions/valueIsNullOrUndef"));
const orderListItems = (listData, accessor) => Object.entries(listData || {})
    .filter((entry) => !(0, valueIsNullOrUndef_1.default)(entry[1]))
    .sort((a, b) => {
    const aValue = accessor(a);
    const bValue = accessor(b);
    if (typeof aValue === 'number' && typeof bValue === 'number') {
        if (aValue < bValue) {
            return -1;
        }
        if (aValue > bValue) {
            return 1;
        }
        return 0;
    }
    const compareA = `${aValue}`.toUpperCase();
    const compareB = `${bValue}`.toUpperCase();
    if (compareA < compareB) {
        return -1;
    }
    if (compareA > compareB) {
        return 1;
    }
    return 0;
});
exports.default = orderListItems;
